import TermsAndConditions from './terms-and-conditions.vue';

export default TermsAndConditions;
